import React, {useEffect, useState} from 'react';

// Services

// Components
import {MyUploadAdapter} from "./MyUploadAdapter";

// UI
import {
  Button,
  DialogContentText,
  Grid,
  LinearProgress,
  makeStyles,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  TextField
} from '@material-ui/core';
import {AddCircle} from "@material-ui/icons";
import Autocomplete from '@material-ui/lab/Autocomplete';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {CKEditor} from '@ckeditor/ckeditor5-react';
// import ChipInput from 'material-ui-chip-input'
import Chip from "@material-ui/core/Chip";

// Utils
import * as Yup from "yup";
import _ from "lodash";
import {optionFaqAdminLabel} from "./add/formatters";
import {MACROTHEMES_TYPES, VERTICALS_LIST} from "../../utils/constants";
import useCountryAxiosInstance from "../../hooks/useCountryAxiosInstance";
import SearchSelect from "../../ui-components/SearchSelect";

const useStyles = makeStyles(() => ({
  formField: {
    width: "100%",
    marginBottom: 15
  },
  addButton: {
    marginTop: 10
  },
  addIcon: {
    width: 30,
    height: 30,
    marginLeft: 10
  },
  chip: {
    margin: '10px',
  },
}))

const FIELD_VALIDATION_REQUIRED_LABEL = "Campo richiesto!";


function AddFaqDialog({open, toggleOpen, openAlert, triplets, fetchFaqs, editableFaq, adminsOptions}) {

  const [_triplets,] = useState(JSON.parse(JSON.stringify(triplets)))
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [keywordLoading, setKeywordLoading] = useState(false);
  const [domanda, setDomanda] = useState();
  const [htmlRisposta, setHtmlRisposta] = useState();
  const [risposta, setRisposta] = useState();
  const [verticalSelected, setVerticalSelected] = useState();
  const [macrotemaSelected, setMacrotemaSelected] = useState();
  const [temaSelected, setTemaSelected] = useState();
  const [addMacrotema, setAddMacrotema] = useState(false);
  const [generateKeywordToggle, setGenerateKeywordToggle] = useState(false);
  const [newMacrotema, setNewMacrotema] = useState();
  const [macrotemaVisibility, setMacrotemaVisibility] = useState(MACROTHEMES_TYPES[2]);
  const [addTema, setAddTema] = useState(false);
  const [newTema, setNewTema] = useState();
  const [chipData, setChipData] = useState([]);
  const [generatedKeywords, setGeneratedKeywords] = useState([]);
  const [riferimenti, setRiferimenti] = useState();
  const [adminSelected, setAdminSelected] = useState();
  const [adminSelectedId, setAdminSelectedId] = useState();
  const timestampId = +new Date();
  let imageCounter = 0;
  const apiRequest = useCountryAxiosInstance();



  useEffect(() => {
    setupEditDialog();
  }, [editableFaq]); // eslint-disable-line react-hooks/exhaustive-deps

  const putNewDocument = {
    "vertical": "",
    "macrotema": "",
    "tema": "",
    "domanda": "banana.",
    "risposta": "Think life.",
    "html_risposta": "",
    "views": 1,
    "feedback_ratio": 0.5,
    "positive_feedback": 1,
    "negative_feedback": 1,
    "keywords_array": [],
    "riferimenti": "",
    "creation_ts": 1617696238,
    "last_update_ts": 1617696238,
    "last_update_views_ts": 1617696238,
    "is_available": 1
  };


  // console.log('AddFaqDialog rendering')

  const schema = Yup.object({
    vertical: Yup.string().required(FIELD_VALIDATION_REQUIRED_LABEL),
    macrotema: Yup.string().required(FIELD_VALIDATION_REQUIRED_LABEL),
    tema: Yup.string().required(FIELD_VALIDATION_REQUIRED_LABEL),
    domanda: Yup.string().required(FIELD_VALIDATION_REQUIRED_LABEL),
    risposta: Yup.string().required(FIELD_VALIDATION_REQUIRED_LABEL)
  });

  const incrementImageCounter = () => {
    imageCounter = imageCounter + 1;
  }

  const setupEditDialog = () => {
    setVerticalSelected(editableFaq ? editableFaq._source.vertical : undefined);
    setMacrotemaSelected(editableFaq ? editableFaq._source.macrotema : undefined);
    setTemaSelected(editableFaq ? editableFaq._source.tema : undefined);
    setDomanda(editableFaq ? editableFaq._source.domanda : undefined);
    setRisposta(editableFaq ? editableFaq._source.risposta : undefined);
    setHtmlRisposta(editableFaq ? editableFaq._source.html_risposta : undefined);
    // setKeywords(editableFaq ? editableFaq._source.keywords_array : undefined);
    if (editableFaq && editableFaq._source.keywords_array !== undefined) {
      editableFaq._source.keywords_array.forEach((data) => {
        if (data.trim().length > 0) {
          setChipData(chipData => [...chipData, data.trim()])
        }
      })
    }
    setRiferimenti(editableFaq ? editableFaq._source.riferimenti : undefined);
    putNewDocument['views'] = editableFaq ? editableFaq._source.views : 1
    putNewDocument['feedback_ratio'] = editableFaq ? editableFaq._source.feedback_ratio : 0.5
    putNewDocument['positive_feedback'] = editableFaq ? editableFaq._source.positive_feedback : 1
    putNewDocument['negative_feedback'] = editableFaq ? editableFaq._source.negative_feedback : 1
    putNewDocument['creation_ts'] = editableFaq ? editableFaq._source.creation_ts : +new Date();
    putNewDocument['last_update_ts'] = editableFaq ? editableFaq._source.last_update_ts : +new Date();
    putNewDocument['last_update_views_ts'] = editableFaq ? editableFaq._source.last_update_views_ts : +new Date();
    putNewDocument['is_available'] = editableFaq ? editableFaq._source.is_available : 1
  }

  const addQuestion = async (newDocument) => {
    const document_id = editableFaq ? editableFaq._id : timestampId;
    newDocument['doc_id'] = document_id;
    apiRequest.put('/assistant/add_update', newDocument).then((result) => {
      openAlert("success", "Domanda creata con successo!");
      fetchFaqs(document_id);
      toggleOpen();

    }).catch((error) => {
      console.log(error)
      openAlert("error", "Impossibile creare la domanda!");
    }).finally(() => setLoading(false))

  }


  const addThemeAndQuestion = (newDocument) => {
    setLoading(true)
    if (newTema) {
      const data = {
        vertical: verticalSelected,
        macrotema: newMacrotema ? newMacrotema : macrotemaSelected,
        tema: String(newTema).trim(),
        riservato_kerakoll: newMacrotema ? macrotemaVisibility.level
          : _triplets.find(element => element['macrotema'] === macrotemaSelected)['riservato_kerakoll'],
        id_referente: newMacrotema ? adminSelectedId
          : _triplets.find(element => element['macrotema'] === macrotemaSelected)['id_referente']
      }

      apiRequest.post('assistant/themes', data)
        .then(res => {
          console.log('nuovo tema aggiunto correttamente', res)
          addQuestion(newDocument)
        }).catch(err => {
        console.log(err)
        openAlert("error", "Errore imprevisto durante l'aggiunta del tema");
        setLoading(false);
      })

    } else {
      addQuestion(newDocument)
    }

  }

  const _onSubmit = () => {
    const newDocument = buildQuestionJson();
    schema.isValid(newDocument)
      .then(valid => {
        if (valid) {
          addThemeAndQuestion(newDocument)
        } else {
          openAlert("error", "Assicurati di aver compilato correttamente tutti i campi");
        }
      })
      .catch(err => console.log(err))
  }

  const buildQuestionJson = () => {
    if (typeof domanda === 'string') {
      putNewDocument['domanda'] = String(domanda).trim()
    }
    if (typeof htmlRisposta === 'string') {
      putNewDocument['html_risposta'] = String(htmlRisposta).trim()
    }
    if (typeof risposta === 'string') {
      putNewDocument['risposta'] = String(risposta).trim()
    }
    if (typeof verticalSelected === 'string') {
      putNewDocument['vertical'] = String(verticalSelected).trim()
    }
    if (typeof macrotemaSelected === 'string') {
      putNewDocument['macrotema'] = String(macrotemaSelected).trim()
    }
    if (typeof temaSelected === 'string') {
      putNewDocument['tema'] = String(temaSelected).trim()
    }
    if (typeof macrotemaSelected === 'string') {
      putNewDocument['macrotema'] = String(macrotemaSelected).trim()
    }
    if (typeof riferimenti === 'string') {
      putNewDocument['riferimenti'] = String(riferimenti).trim()
    }
    putNewDocument['keywords_array'] = chipData;
    return putNewDocument
  }

  const custom_config = {
    extraPlugins: [MyCustomUploadAdapterPlugin],
    toolbar: {
      items: [
        'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
        'blockQuote', 'insertTable', '|', 'imageUpload', 'undo', 'redo'
      ]
    },
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
    }
  }

  function onVerticalChange(event, vertical) {
    setVerticalSelected(vertical)
    setMacrotemaSelected(undefined)
    setTemaSelected(undefined)
    setNewMacrotema(undefined)
    setNewTema(undefined)
  }

  function onMacrotemaChange(event, macrotema) {
    setMacrotemaSelected(macrotema)
    setTemaSelected(undefined)
    setNewMacrotema(undefined)
    setNewTema(undefined)
  }

  function onAdminChange(event, admin) {
    setAdminSelectedId(admin ? admin['id'] : undefined)
    setAdminSelected(admin)
  }

  const handleNewMacrotema = (e) => {
    setNewMacrotema(e.target.value)
  }

  const handleNewTema = (e) => {
    setNewTema(e.target.value)
  }

  const generateKeywords = () => {
    setGeneratedKeywords([]);
    setKeywordLoading(true)
    apiRequest.post('assistant/keywords', {
      'domanda': domanda,
      'risposta': risposta
    }).then((result) => {
      result['keywords_list'].forEach((data) => {
        if (data.trim().length > 0) {
          setGeneratedKeywords(generatedKeywords => [...generatedKeywords, data.trim()])
        }
      })
    }).catch((error) => {
      console.log(error)
      openAlert("error", "Impossibile generare le keywords");
    }).finally(() => setKeywordLoading(false))

  }

  const handleChipDelete = (chipToDelete) => {
    setChipData((chips) => chips.filter((chip) => chip !== chipToDelete));
  };

  const handleChipClick = (chipToAdd) => {
    setChipData(chipData => [...chipData, chipToAdd]);
  };

  const handleSuggestedKeywordChipClick = (chipToAdd) => {
    setChipData(chipData => [...chipData, chipToAdd]);
    setGeneratedKeywords((generatedKeywords) => generatedKeywords.filter((chip) => chip !== chipToAdd));

  };

  function MyCustomUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return new MyUploadAdapter(loader, timestampId, imageCounter, incrementImageCounter, apiRequest)
    }
  }


  return (
    <div key='addFaqDialog' className="z-100">
      <Dialog
        open={open}
        onClose={toggleOpen}
        disableEnforceFocus={true}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="md">
        <DialogTitle id="form-dialog-title">{editableFaq ? 'Modifica domanda' : 'Aggiungi'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Autocomplete
                id="combo-box-vertical"
                autoSelect
                autoComplete
                options={VERTICALS_LIST}
                onChange={onVerticalChange}
                value={verticalSelected || null}
                className={classes.formField}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Seleziona vertical"
                    variant="outlined"
                  />
                )}
              />

            </Grid>
            <Grid item xs={11}>
              <Autocomplete
                id="combo-box-macrotema"
                autoSelect
                autoComplete
                options={[...new Set(_triplets.filter(obj => obj.vertical === verticalSelected).map(item => item.macrotema))]}
                onChange={onMacrotemaChange}
                value={macrotemaSelected || null}
                className={classes.formField}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Seleziona macrotema"
                    variant="outlined"
                  />
                )}
                disabled={!verticalSelected}
              />
            </Grid>
            <Grid item xs={1}>
              <Button
                color="primary"
                className={classes.addButton}
                onClick={() => setAddMacrotema(true)}
                startIcon={<AddCircle className={classes.addIcon}/>}
                disabled={!verticalSelected}
              />
            </Grid>
            {addMacrotema &&
            <Grid item xs={12}>
              <Paper style={{padding: 20, marginBottom: 20}}>
                <Typography variant="subtitle1" style={{marginBottom: 10}}>
                  Aggiungi un nuovo macrotema per il vertical <b>{verticalSelected}</b>
                </Typography>
                <TextField
                  label="Nuovo macrotema"
                  variant="outlined"
                  className={classes.formField}
                  onChange={handleNewMacrotema}
                />
                <Autocomplete
                  id="combo-box-macrotema-admin"
                  options={adminsOptions}
                  getOptionLabel={optionFaqAdminLabel}
                  renderOption={optionFaqAdminLabel}
                  onChange={onAdminChange}
                  value={adminSelected || null}
                  className={classes.formField}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Seleziona referente"
                      variant="outlined"
                    />
                  )}
                  disabled={!verticalSelected}
                />
                <Autocomplete
                  id="level-visibility"
                  options={MACROTHEMES_TYPES}
                  getOptionLabel={(i) => `${i['label']}`}
                  renderOption={(i) => `${i['label']}`}
                  onChange={(e, v) => {
                    setMacrotemaVisibility(v)
                  }}
                  value={macrotemaVisibility}
                  className={classes.formField}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Indica il livello di visibilità"
                      variant="outlined"
                    />
                  )}
                  disabled={!verticalSelected}
                />

                <div style={{marginTop: 10, height: 30, textAlign: "center"}}>
                  <Button
                    onClick={() => setAddMacrotema(false)}
                    variant="contained"
                    style={{float: "left", fontSize: 10}}>
                    Chiudi
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    style={{float: "right", marginBottom: 10, fontSize: 10}}
                    onClick={() => {
                      _triplets.push({vertical: verticalSelected, macrotema: newMacrotema, tema: ''})
                      setMacrotemaSelected(newMacrotema)
                      setAddMacrotema(false)
                    }}
                    disabled={!newMacrotema || !adminSelected}
                  >
                    Aggiungi
                  </Button>
                </div>
              </Paper>
            </Grid>
            }
            <Grid item xs={11}>
              <Autocomplete
                id="combo-box-tema"
                autoSelect
                autoComplete
                options={[...new Set(_triplets.filter(obj => obj.macrotema === macrotemaSelected).map(item => item.tema))]}
                onChange={(e, selectedObject) => {
                  setTemaSelected(selectedObject)
                  setNewTema(undefined)
                }}
                value={temaSelected || null}
                className={classes.formField}
                disabled={!macrotemaSelected}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Seleziona tema"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid item xs={1}>
              <Button
                color="primary"
                className={classes.addButton}
                onClick={() => setAddTema(true)}
                startIcon={<AddCircle className={classes.addIcon}/>}
                disabled={!macrotemaSelected}
              />
            </Grid>
            {addTema &&
            <Grid item xs={12}>
              <Paper style={{padding: 20, marginBottom: 20}}>
                <Typography variant="subtitle1" style={{marginBottom: 10}}>
                  Aggiungi un nuovo tema per il macrotema <b>{macrotemaSelected}</b>
                </Typography>
                <TextField
                  label="Nuovo tema"
                  variant="outlined"
                  className={classes.formField}
                  onChange={handleNewTema}
                />
                <div style={{marginTop: 10, height: 30, textAlign: "center"}}>
                  <Button
                    onClick={() =>
                      setAddTema(false)
                    }
                    variant="contained"
                    style={{float: "left", fontSize: 10}}>
                    Chiudi
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    style={{float: "right", marginBottom: 10, fontSize: 10}}
                    onClick={() => {
                      _triplets.push({vertical: verticalSelected, macrotema: macrotemaSelected, tema: newTema})
                      setTemaSelected(newTema)
                      setAddTema(false)
                    }}>
                    Aggiungi
                  </Button>
                </div>
              </Paper>
            </Grid>
            }
            <Grid item xs={12}>
              <TextField
                id="domanda-textarea"
                label="Testo della domanda"
                placeholder="Inserisci il testo della domanda"
                variant="outlined"
                className={classes.formField}
                onChange={(e) => {
                  setDomanda(e.target.value);
                }}
                value={domanda}
                disabled={!temaSelected}
                multiline
                inputProps={{style: {height: 40}}}
              />

            </Grid>
            <Grid item xs={12}>
              <DialogContentText>
                Contenuto della risposta:
              </DialogContentText>
            </Grid>
            <Grid item xs={12}>
              <CKEditor
                editor={ClassicEditor}
                data={htmlRisposta}
                config={custom_config}
                onReady={editor => {
                  if (editor) {
                    editor.editing.view.change(writer => {
                      writer.setStyle(
                        "height",
                        "200px",
                        editor.editing.view.document.getRoot()
                      );
                    });
                  }
                }}
                onChange={(event, editor) => {
                  setHtmlRisposta(editor.getData());
                  setRisposta(editor.getData().replace(/<[^>]*>?/gm, ' ').replace('&nbsp;', ' '));
                }}

              />
            </Grid>
            <Grid item xs={10}>
              {chipData &&

                // <ChipInput
                //   value={chipData}
                //   onAdd={(chip) => {
                //     handleChipClick(chip)
                //   }}
                //   onDelete={(chip) => {
                //     handleChipDelete(chip)
                //   }}
                //   variant="outlined"
                //   fullWidth={true}
                //   label="Keywords"
                //   style={{marginTop: 10, marginBottom: 20}}
                // />

                <SearchSelect
                  value={chipData.map((kw) => ({label: kw, value: kw}))}
                  onChange={(selected) => {
                    const toAdd = selected.filter((kw) => !chipData.includes(kw));
                    if (toAdd.length)
                      handleChipClick(toAdd[0]);
                    const toDelete = chipData.filter((kw) => !selected.includes(kw));
                    if (toDelete.length)
                      handleChipDelete(toDelete[0]);
                  }}
                  options={generatedKeywords.map((kw) => ({label: kw, value: kw}))}
                  isMulti
                  menuIsOpen={false}
                  closeMenuOnSelect={false}
                />
              }
            </Grid>
            <Grid item xs={2}>
              <Button
                color="primary"
                variant="contained"
                disabled={!domanda || !risposta}
                onClick={() => {
                  generateKeywords();
                  setGenerateKeywordToggle(true);
                }}
                style={{marginLeft: 2, marginTop: 4, height: '2.5rem'}}
              >
                <span className="whitespace-nowrap text-xs">Genera keyword</span>
              </Button>
            </Grid>
            {generateKeywordToggle &&
            <Grid item xs={12}>
              <Paper style={{padding: 20, marginBottom: 20}}>
                <LinearProgress style={{visibility: keywordLoading ? 'visible' : 'hidden'}}/>
                {!keywordLoading &&
                <>
                  <Typography variant="subtitle1" style={{marginBottom: 10}}>
                    Ecco le keyword generate, seleziona quelle da inserire:
                  </Typography>
                  {generatedKeywords &&
                  generatedKeywords.map((data) => {
                    return (
                      <Chip
                        key={data + '_key'}
                        label={data}
                        onClick={() => {
                          handleSuggestedKeywordChipClick(data)
                        }}
                        className={classes.chip}
                      />
                    );
                  })
                  }
                </>
                }
              </Paper>
            </Grid>
            }
            <Grid item xs={12}>
              <TextField
                id="Riferimento-textarea"
                label="Riferimento"
                placeholder="Inserisci il riferimento"
                variant="outlined"
                className={classes.formField}
                onChange={(e) => {
                  setRiferimenti(e.target.value);
                }}
                value={riferimenti}
                multiline
              />
            </Grid>
            <Grid item xs={12} style={{marginTop: 8, marginBottom: 10}}>
              <LinearProgress style={{visibility: loading ? 'visible' : 'hidden', marginBottom: 5}}/>
              <Button onClick={toggleOpen} variant="contained" style={{float: "left"}}>
                Chiudi
              </Button>
              <Button
                color="primary"
                variant="contained"
                style={{float: "right"}}
                disabled={!domanda || !risposta}
                onClick={_onSubmit}>
                {editableFaq ? 'Modifica' : 'Aggiungi'}
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default React.memo(AddFaqDialog, (props, nextProps) => {
  // Render component only when users changes
  return _.isEqual(props.editableFaq, nextProps.editableFaq);
})
